import React from "react";
import { Package, Edit2, Trash2, Loader2 } from "lucide-react";
import { STATUS_COLORS, formatCurrency, formatDate } from "./useAdminOrders";

export default function AdminOrdersTable({
  loading, filteredOrders, pagination, setPagination,
  onEdit, onDelete,
}) {
  return (
    <div className="bg-white rounded-xl border border-[--border] overflow-hidden">
      {loading ? (
        <div className="flex items-center justify-center py-20">
          <Loader2 className="animate-spin text-[--accent]" size={32} />
        </div>
      ) : filteredOrders.length === 0 ? (
        <div className="text-center py-20 text-[--text-muted]">
          <Package size={48} className="mx-auto mb-3 opacity-30" />
          <p>No orders found</p>
        </div>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-[--bg-cream] border-b border-[--border]">
              <tr>
                <th className="text-left px-4 py-3 font-medium text-[--text-muted]">Order #</th>
                <th className="text-left px-4 py-3 font-medium text-[--text-muted]">Customer</th>
                <th className="text-left px-4 py-3 font-medium text-[--text-muted]">Amount</th>
                <th className="text-left px-4 py-3 font-medium text-[--text-muted]">Discount</th>
                <th className="text-left px-4 py-3 font-medium text-[--text-muted]">Final</th>
                <th className="text-left px-4 py-3 font-medium text-[--text-muted]">Payment</th>
                <th className="text-left px-4 py-3 font-medium text-[--text-muted]">Status</th>
                <th className="text-left px-4 py-3 font-medium text-[--text-muted]">Date</th>
                <th className="text-left px-4 py-3 font-medium text-[--text-muted]">Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredOrders.map((order) => (
                <tr key={order.id} className="border-b border-[--border] hover:bg-[--bg-cream]/50" data-testid={`order-row-${order.id}`}>
                  <td className="px-4 py-3 font-medium">{order.order_number}</td>
                  <td className="px-4 py-3">
                    <div>{order.customer_name}</div>
                    <div className="text-[11px] text-[--text-muted]">{order.customer_phone}</div>
                  </td>
                  <td className="px-4 py-3">{formatCurrency(order.amount)}</td>
                  <td className="px-4 py-3">
                    {order.discount_percent > 0 ? `${order.discount_percent}%` :
                     order.discount_amount > 0 ? formatCurrency(order.discount_amount) : "-"}
                  </td>
                  <td className="px-4 py-3 font-medium text-green-600">{formatCurrency(order.final_amount)}</td>
                  <td className="px-4 py-3">{order.payment_mode || "-"}</td>
                  <td className="px-4 py-3">
                    <span className={`px-2 py-0.5 rounded-full text-[11px] font-medium ${STATUS_COLORS[order.status] || "bg-gray-100"}`}>
                      {order.status}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-[--text-muted]">{formatDate(order.created_at)}</td>
                  <td className="px-4 py-3">
                    <div className="flex items-center gap-1">
                      <button onClick={() => onEdit(order)} className="btn-icon" title="Edit" data-testid={`edit-order-${order.id}`}>
                        <Edit2 size={14} />
                      </button>
                      <button onClick={() => onDelete(order.id)} className="btn-icon text-red-500 hover:bg-red-50" title="Delete" data-testid={`delete-order-${order.id}`}>
                        <Trash2 size={14} />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {pagination.pages > 1 && (
        <div className="flex items-center justify-between px-4 py-3 border-t border-[--border]">
          <p className="text-sm text-[--text-muted]">
            Page {pagination.page} of {pagination.pages}
          </p>
          <div className="flex gap-2">
            <button
              onClick={() => setPagination((p) => ({ ...p, page: Math.max(1, p.page - 1) }))}
              disabled={pagination.page === 1}
              className="btn-secondary text-sm"
            >
              Previous
            </button>
            <button
              onClick={() => setPagination((p) => ({ ...p, page: Math.min(p.pages, p.page + 1) }))}
              disabled={pagination.page === pagination.pages}
              className="btn-secondary text-sm"
            >
              Next
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
